module.exports = __webpack_public_path__ + "static/media/room-11.f08fee37.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/room-11.jpeg
// module id = 75
// module chunks = 0